import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import styles from './Tooltip.module.scss';
import cn from 'classnames';
const Tooltip = ({ content, className, children, onClick }) => {
    const [active, setActive] = useState(false);
    let TooltipEnum;
    (function (TooltipEnum) {
        TooltipEnum["OPEN"] = "open";
        TooltipEnum["CLOSE"] = "close";
    })(TooltipEnum || (TooltipEnum = {}));
    const tooltipState = {
        [TooltipEnum.OPEN]: true,
        [TooltipEnum.CLOSE]: false
    };
    const handleOpenTooltip = (tooltip) => {
        setActive(tooltipState[tooltip]);
    };
    return (_jsxs("div", Object.assign({ "data-testid": "tooltipWrapper", onClick: onClick, onMouseLeave: () => handleOpenTooltip('close'), onMouseEnter: () => handleOpenTooltip('open'), className: cn(styles.element, className, active && styles['isActive'], 'd-flex align-items-center') }, { children: [children, active && content && (_jsx("div", Object.assign({ className: cn(styles.tooltip) }, { children: _jsx("span", Object.assign({ className: cn(styles.context) }, { children: content })) })))] })));
};
export default Tooltip;
